import { YesOrNo } from '../EternalAds.interface'

export const parseYesOrNo = (value?: YesOrNo): boolean => Boolean(value && value === YesOrNo.YES)
